import React from 'react';
import { Stack, StackChild } from '@tanium/react-stack';
import { FormTitle } from './FormTitle';

export interface FormHeaderProps {
  /**
   * The title to display.
   */
  title?: React.ReactNode;
}

export const FormHeader = ({ title }: FormHeaderProps) => (
  <Stack itemSpacing={2}>
    <StackChild grow={1}>{title && <FormTitle>{title}</FormTitle>}</StackChild>
  </Stack>
);
